import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorMyClonesState = (state: RootState) => state.myClones;

export const selectorMyClones = createSelector(
  selectorMyClonesState,
  (myClonesState) => myClonesState.myClones
);
